import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import type { ReduxDispatch, ReduxRootState } from './store'

export const useReduxDispatch = () => useDispatch<ReduxDispatch>()
export const useReduxSelector: TypedUseSelectorHook<ReduxRootState> = useSelector
